<template>
  <div class="soft-container">
    <div class="soft-title">{{ languages.softInstall.coreUpdate }}</div>
    <el-scrollbar height="100px" class="soft-list">
      <div class="single-container" v-for="item in upgradeSoftDetails" :key="item.id">
        <div class="soft-preview">
          <div class="soft-info">
            <!-- <div class="soft-check">
              <el-checkbox v-model="checked"></el-checkbox>
            </div> -->
            <img class="img-preview" :src="item.icon" alt="" />
            <div>
              <div class="soft-name">
                {{ item.name }}
                <span class="soft-desc">
                  {{ languages.softInstall.softsize }}: {{ item.size }}MB
                </span>
              </div>
              <div class="soft-desc">
                {{ languages.softInstall.updatetime }}: {{ formatDate(item.updateTime) }} ( Ver:
                {{ item.version }} )
              </div>
              <div class="soft-desc">
                {{ languages.softInstall.softdesc }}: {{ item.description }}
              </div>
            </div>
          </div>
          <div class="button-container">
            <el-button
              v-if="item.upgradeStatus === 0"
              type="primary"
              size="medium"
              disabled
              :loading="item.id === loaddingId"
              class="is-disable"
              >{{
                item.id === loaddingId && isRunning
                  ? installStep(step, item.upgradeStatus)
                  : languages.softInstall.latest
              }}</el-button
            >
            <el-button
              v-if="item.upgradeStatus === 1"
              type="primary"
              size="medium"
              @click="handleInstall(item)"
              :disabled="errorStatus || isRunning"
              :loading="item.id === loaddingId"
              :class="item.id !== loaddingId && isRunning ? 'is-disable' : ''"
              >{{
                item.id === loaddingId && isRunning
                  ? installStep(step, item.upgradeStatus)
                  : languages.softInstall.upgrade
              }}</el-button
            >
            <el-button
              v-if="item.upgradeStatus === 2"
              type="primary"
              size="medium"
              @click="handleInstall(item)"
              :disabled="errorStatus || isRunning"
              :loading="item.id === loaddingId"
              :class="item.id !== loaddingId && isRunning ? 'is-disable' : ''"
              >{{
                item.id === loaddingId && isRunning
                  ? installStep(step, item.upgradeStatus)
                  : languages.install
              }}</el-button
            >
          </div>
        </div>
        <div class="percent-bar">
          <div class="down-icon" v-if="item.id === loaddingId && showProgressBar">
            <i class="el-icon-download"></i>
          </div>
          <el-tooltip
            v-if="item.id === loaddingId && showProgressBar"
            :content="languages.softInstall.downProgress + ': ' + parseInt(downPercent) + '%'"
            :visible-arrow="false"
            placement="top"
            popper-class="tooltip-style"
          >
            <el-progress :percentage="parseInt(downPercent)"></el-progress>
          </el-tooltip>
          <el-tooltip
            v-if="item.id === loaddingId && showProgressBar"
            :content="languages.softInstall.cancel"
            :visible-arrow="false"
            placement="bottom"
            popper-class="tooltip-style"
          >
            <div class="cancel-button">
              <i @click="stopDownload" class="el-icon-circle-close"></i>
            </div>
          </el-tooltip>
        </div>
      </div>
    </el-scrollbar>
    <apply-dialog
      :languages="languages"
      type="info"
      :show="dialogApplyVisible"
      :software="applySoftware"
      :submitting="submitting"
    ></apply-dialog>
    <info-dialog
      :languages="languages"
      :type="infoType"
      :confirm="infoConfirm"
      :show="dialogInfoVisible"
      :tips="infoTips"
      :submitting="submitting"
    ></info-dialog>
    <confirm-dialog
      :languages="languages"
      :type="confirmType"
      :operate="operateMethod"
      :show="dialogConfirmVisible"
      :softname="installing"
    ></confirm-dialog>
  </div>
</template>

<script>
import ApplyDialog from 'components/dialogs/ApplyDialog.vue';
import InfoDialog from 'components/dialogs/InfoDialog.vue';
import ConfirmDialog from 'components/dialogs/ConfirmDialog.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import socket from 'common/socket';
import tools from 'common/tools';
import { ubtRegister, ubtSendTrace } from 'utils/ubt';

export default {
  components: {
    ApplyDialog,
    InfoDialog,
    ConfirmDialog,
  },
  inject: ['homeTemplate'],
  data() {
    return {
      count: 0,
      isMessageShow: false,
      dialogApplyVisible: false,
      dialogInfoVisible: false,
      dialogConfirmVisible: false,
      screenWidth: 0,
      screenHeight: 0,
      listHeight: 0,
      applySoftware: {},
      loaddingId: '',
      submitting: false,
      infoTips: {},
      infoType: 'info',
      infoConfirm: false,
      step: 'check',
      tempSocketDatas: '',
      tempItem: '',
      saveMode: false,
      installing: '',
      confirmType: '',
      operateMethod: 'install',
      connectSocketTimer: '',
      percentInterval: '',
      downPercent: 0,
      showProgressBar: false,
      downloadRetryFlag: false,
    };
  },
  computed: {
    ...mapState([
      'homeHidden',
      'languages',
      'errorStatus',
      'userInfo',
      'selectSoftDetails',
      'upgradeSoftDetails',
      'isRunning',
      'softTypeList',
      'deviceName',
      'recommendSoftware',
      'recommendSoftwareEn',
      'socketStatus',
      'isNewService',
      'isAdministrator',
    ]),
    formatDate() {
      return (data) => {
        const date = /\d{4}-\d{1,2}-\d{1,2}/g.exec(data);
        return date[0];
      };
    },
    installStep() {
      return (step, status) => {
        switch (step) {
          case 'check':
            return this.languages.softInstall.checking;
          case 'down':
            return this.languages.softInstall.downloading;
          case 'cancel':
            return this.languages.softInstall.canceling;
          default:
            if (status === 1) return this.languages.softInstall.upgrading;
            if (status === 2) return this.languages.softInstall.installing;
            return '';
        }
      };
    },
  },
  methods: {
    ...mapMutations([
      'setPageNow',
      'setHomeHidden',
      'setSearchHidden',
      'setShowFooter',
      'setIsRunning',
      'setSelectSoftDetails',
      'setSoftSearch',
      'setSoftTabPage',
      'setFooterTips',
      'setDownloadSource',
      'setErrorTips',
      'setPvId',
      'setDebugInfos',
      'setIsAdministrator',
    ]),
    ...mapActions(['softwareInstall', 'saveLog']),
    showDialog(title, info, type = 'info', confirm = false) {
      this.infoType = type;
      this.infoConfirm = confirm;
      this.infoTips = { title, info };
      this.dialogInfoVisible = true;
      /* reset the installing status */
      this.loaddingId = '';
      this.setIsRunning(false);
    },
    /* software install */
    handleInstall(item) {
      this.stepShow = false;
      this.loaddingId = item.id;
      this.setIsRunning(true);
      if (this.isNewService) {
        this.newInstallPrecheck(this.deviceName, item);
      } else {
        this.installPrecheck(this.deviceName, item);
      }
    },
    /* software installing */
    async installPrecheck(pcCode, item) {
      this.tempSocketDatas = '';
      /* 3. get the software crypted datas from api */
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: item.id,
        pcName: pcCode,
      });
      console.log('installPrecheck', res);
      if (res.status === 'failed') {
        /* get crypted datas failed */
        this.showDialog(
          this.languages.softInstall.upgradeFail,
          this.languages.softInstall.contact,
          'warn',
        );
        this.saveLog({
          title: 'api_error',
          target: 'installPrecheck',
          lan: this.languages.lan,
          softwareName: item.name,
          softwareId: item.id,
          description: res.data,
          reserve1: 'SoftwareUpgrade > installPrecheck',
        });
        return;
      }
      /* 4. to get the datas for local service installation */
      const index = this.softTypeList.findIndex((itm) => item.typeId === itm.id);
      const installDatas = {
        username: this.userInfo.username,
        softid: item.id,
        regVer: item.version,
        lan: this.languages.lan,
        path: res.data.encryptPath,
        key: res.data.key,
        type: this.softTypeList[index].name,
      };
      // console.log('installDatas', installDatas);
      const socketDatas = tools.toUnicode(JSON.stringify(installDatas));
      // console.log('socketDatas', socketDatas);
      /* 5. send download command to local service with install datas */
      this.step = 'check';
      this.tempSocketDatas = socketDatas;
      this.tempItem = item;
      socket.sendSocket(0, `idesk_check(${socketDatas})`, (result) => {
        console.log('idesk_check', result);
        const status = result.result;
        if (status === 'failed') {
          switch (result.error_msg) {
            case 'disk full':
              this.showDialog(
                this.languages.softInstall.installNote,
                this.languages.softInstall.diskFull.replace(/@/g, result.disk),
                'warn',
              );
              break;
            case 'process exist':
              this.showDialog(
                this.languages.softInstall.installNote,
                this.languages.softInstall.processExist,
                'warn',
              );
              break;
            default:
              this.showDialog(
                this.languages.softInstall.upgradeFail,
                this.languages.softInstall.contact,
                'warn',
              );
              break;
          }
          this.saveLog({
            title: 'check_error',
            target: 'installPrecheck',
            lan: this.languages.lan,
            softwareName: item.name,
            softwareId: item.id,
            description: result.error_msg,
            reserve1: 'SoftwareUpgrade > installPrecheck',
          });
          this.tempSocketDatas = '';
          this.tempItem = '';
          return;
        }
        this.installSoftware();
      });
    },
    async newInstallPrecheck(pcCode, item) {
      this.tempSocketDatas = '';
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: item.id,
        pcName: pcCode,
      });
      if (res.status === 'failed') {
        /* get crypted datas failed */
        this.showDialog(
          this.languages.softInstall.installFail,
          this.languages.softInstall.contact,
          'warn',
        );
        this.saveLog({
          title: 'api_error',
          target: 'newInstallPrecheck',
          softwareName: item.name,
          softwareId: item.id,
          description: res.data,
          reserve1: 'SoftwareUpgrade > installPrecheck',
        });
        this.setErrorTips(`Api Error in newInstall> ${res.error_msg}`);
        return;
      }
      const index = this.softTypeList.findIndex((itm) => item.typeId === itm.id);
      const installDatas = {
        username: this.userInfo.username,
        softid: item.id,
        regVer: item.version,
        lan: this.languages.lan,
        path: res.data.encryptPath,
        key: res.data.key,
        type: this.softTypeList[index].name,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(installDatas));
      this.step = 'check';
      this.tempSocketDatas = socketDatas;
      this.tempItem = item;

      const checkSoft = `{'name':'${item.regName}','version':'${item.version}'}`;
      const checkCommand = `({"level":"user","method":"check_version", "data":"${checkSoft}"})`;
      console.log(checkCommand);
      socket.sendSocket(2, checkCommand, (rs) => {
        const rlt = JSON.parse(rs);
        console.log('rlt', rlt);
        if (rlt.result === 'success') {
          const status = JSON.parse(rlt.data)[item.regName];
          let showTips = '';
          switch (status) {
            case '=':
              showTips = this.languages.softInstall.sameVer;
              break;
            case '<':
              showTips = this.languages.softInstall.highVer;
              break;
            case '>':
              showTips = this.languages.softInstall.lowVer;
              break;
            case '<>':
              showTips = this.languages.softInstall.hasVer;
              break;
            default:
              showTips = '';
              break;
          }
          console.log('newInstallPrecheck ======> ', item);
          if (showTips) {
            if (item.installCheckFlag === 1) {
              this.showDialog(
                this.languages.softInstall.installNote,
                this.languages.softInstall.needUninstall,
                'warn',
                false,
              );
            } else {
              this.showDialog(this.languages.softInstall.installNote, showTips, 'warn', true);
            }
          } else {
            this.newDownloadSoftware();
          }
        }
      });
    },
    async newDownloadSoftware() {
      const downStartTime = new Date().getTime();
      const downCommand = `({"level":"user", "method":"soft_download", "data":"${this.tempSocketDatas}"})`;
      socket.sendSocket(2, downCommand, async (rs) => {
        const res = JSON.parse(rs);
        if (res.result === 'failed') {
          const { downBlock } = this.languages;
          if (res.error === 'Process Exist') {
            this.showDialog(
              this.languages.softInstall.installNote,
              this.languages.softInstall.processExist,
              'warn',
            );
          } else if (res.error.includes('Out Of Disk Space')) {
            const disk = res.error.slice(res.error.indexOf('“') + 1, res.error.indexOf('”'));
            this.showDialog(
              this.languages.softInstall.installNote,
              this.languages.softInstall.diskFull.replace(/@/g, disk),
              'warn',
            );
          } else if (res.error.toLowerCase().indexOf(downBlock) > -1) {
            // 提权重启软件模组
            this.setIsAdministrator(false);
            this.homeTemplate.initSoftModel('ads', () => {
              console.log('restart softmodel success');
              this.newDownloadSoftware();
            });
          } else {
            this.showDialog(
              this.languages.softInstall.installFail,
              this.languages.softInstall.contact,
              'warn',
            );
            this.setErrorTips(`newDownloadSoftware > ${res.error}`);
            this.tempSocketDatas = '';
            this.tempItem = '';
            this.saveLog({
              title: 'command_error',
              target: 'newDownloadSoftware',
              softwareName: this.tempItem.name,
              softwareId: this.tempItem.id,
              description: res.error,
              reserve1: 'SoftwareUpgrade > newDownloadSoftware',
            });
          }
          return;
        }
        if (res.data.includes('%') && res.type === 'Download') {
          this.showProgressBar = true;
          this.downPercent = res.data.replace('%', '');
          const totalSize = this.tempItem.size;
          const downSize = Math.round(totalSize * (Number(this.downPercent) / 100));
          if (downSize && totalSize) {
            this.setFooterTips(`${downSize}MB / ${totalSize}MB`);
            this.setDownloadSource(res.info);
          }
        }

        if (res.data === 'File Exist' || res.data === 'Download Finished') {
          this.showProgressBar = false;
          const downTime = new Date().getTime() - downStartTime;
          ubtSendTrace(
            245278,
            'sw_install',
            'download_suc',
            this.tempItem.name,
            this.tempItem.id,
            '',
            this.pvId,
          );
          this.saveLog({
            title: 'download_success',
            target: 'newDownloadSoftware',
            softwareName: this.tempItem.name,
            softwareId: this.tempItem.id,
            description: 'normal',
            reserve1: 'SoftwareUpgrade > newDownloadSoftware',
            reserve2: Math.round(downTime / 1000),
            reserve3: res.data === 'File Exist' ? res.data : res.info,
          });
          if (!this.isAdministrator) {
            this.homeTemplate.initSoftModel('adf', () => {
              this.newInstallSoftware();
            });
          } else {
            this.newInstallSoftware();
          }
        }
      });
    },
    async newInstallSoftware() {
      this.step = 'install';
      const userLevel = this.isAdministrator ? 'user' : 'adf';
      const installCommand = `({"level":"${userLevel}", "method":"soft_install", "data":"${this.tempSocketDatas}"})`;
      socket.sendSocket(2, installCommand, async (is) => {
        const ires = JSON.parse(is);
        if (ires.result === 'failed') {
          if (ires.error.includes('"exitCode":1')) {
            this.saveLog({
              title: 'install_cancel',
              target: 'newInstallSoftware',
              softwareName: this.tempItem.name,
              softwareId: this.tempItem.id,
              description: `Upgrade Cancel > ${ires.error}`,
              reserve1: 'SoftwareUpgrade > newInstallSoftware',
              reserve2: ires.info,
            });
            this.setDebugInfos(['newInstallSoftware Upgrade Cancel', 'Install Canceled']);
            if (!this.isAdministrator) this.homeTemplate.initSoftModel('ads');
            this.loaddingId = '';
            this.setIsRunning(false);
            return;
          }
          let specialExitCodeFlag = false;
          if (this.tempItem.exitCode) {
            console.log('specialExitCodeFlag check start');
            let errorObject = null;
            try {
              errorObject = JSON.parse(ires.error);
            } catch {
              console.log('install result error json parse failed', ires.error);
            }
            if (errorObject != null) {
              const specialCodeList = this.tempItem.exitCode.split(',');
              if (
                errorObject.exitCode !== 0 &&
                specialCodeList.includes(errorObject.exitCode.toString())
              ) {
                specialExitCodeFlag = true;
              }
            }
          }
          this.downloadRetryFlag = !this.downloadRetryFlag;
          if (!specialExitCodeFlag) {
            if (ires.error.startsWith('Wrong Hash')) {
              if (this.downloadRetryFlag) {
                this.$message({
                  showClose: true,
                  message: this.languages.softInstall.downloadRetry,
                  duration: 5000,
                  type: 'warning',
                });
                this.saveLog({
                  title: 'download_retry',
                  target: 'newInstallSoftware',
                  softwareName: this.tempItem.name,
                  softwareId: this.tempItem.id,
                  description: `Upgrade Retry > ${ires.error}`,
                  reserve1: 'SoftwareUpgrade > newInstallSoftware',
                  reserve2: ires.info,
                });
                this.newDownloadSoftware();
                return;
              }
            }
            this.setDebugInfos(['newInstallSoftware Upgrade Error', ires.error]);
            this.setErrorTips(`Upgrade Error > ${ires.error}`);
            this.showDialog(
              this.languages.softInstall.installFail,
              this.languages.softInstall.contact,
              'warn',
            );
            this.saveLog({
              title: 'install_error',
              target: 'newInstallSoftware',
              softwareName: this.tempItem.name,
              softwareId: this.tempItem.id,
              description: `Upgrade Error > ${ires.error}`,
              reserve1: 'SoftwareUpgrade > newInstallSoftware',
              reserve2: ires.info,
            });
            if (!this.isAdministrator) this.homeTemplate.initSoftModel('ads');
            return;
          }
          this.installSuccessHaneler(ires);
        }
        if (ires.data === 'Install Success') {
          this.installSuccessHaneler(ires);
        }
      });
    },
    installSuccessHaneler(ires) {
      this.downloadRetryFlag = false;
      let showInfo =
            this.tempItem.softType && this.tempItem.softType !== 0
              ? `${this.languages.softInstall.installInfo}\n${this.languages.softInstall.authTips}`
              : this.languages.softInstall.installInfo;
      if (this.tempItem.softType && this.tempItem.softType !== 0) {
        showInfo += `\n${this.languages.softInstall.authTips}`;
      }
      if (this.tempItem.restart) {
        showInfo += `\n${this.languages.softInstall.needRestart}`;
      }
      this.showDialog(this.languages.softInstall.installed, showInfo);
      ubtSendTrace(
        245278,
        'sw_install',
        'upgrade_suc',
        this.tempItem.name,
        this.tempItem.id,
        '',
        this.pvId,
      );
      this.saveLog({
        title: 'install_success',
        target: 'newInstallSoftware',
        softwareName: this.tempItem.name,
        softwareId: this.tempItem.id,
        description: 'Upgrade Success',
        reserve1: 'SoftwareUpgrade > newInstallSoftware',
        reserve2: ires.info,
      });
      this.step = 'check';
      this.tempSocketDatas = '';
      this.tempItem = '';
      this.setFooterTips('');
      this.handleClean();
      if (this.isAdministrator) {
        this.homeTemplate.getUpgradeSoftList();
        return;
      }
      this.homeTemplate.initSoftModel('ads', (res) => {
        console.log('res!', res);
        this.homeTemplate.getUpgradeSoftList();
      });
    },
    installSoftware() {
      this.isMessageShow = true;
      this.saveMode = true;
      // console.log('installSoftware', this.tempItem);
      this.loaddingId = this.tempItem.id;
      this.setIsRunning(true);
      this.dialogInfoVisible = false;
      this.step = 'down';
      this.tempItem.lan = this.languages.lan;
      if (this.isNewService) {
        this.newDownloadSoftware();
        return;
      }
      // console.log(this.tempSocketDatas);
      socket.sendSocket(0, `idesk_download2(${this.tempSocketDatas})`, (res) => {
        const status = res.result;
        console.log('idesk_download2 >>>>>', res);
        if (status === 'failed') {
          this.setDebugInfos(['SoftwareInstall > download2', res.error_msg]);
          this.setErrorTips(res.error_msg);
          this.setDebugData(this.tempSocketDatas);
          this.showDialog(
            this.languages.softInstall.installFail,
            this.languages.softInstall.contact,
            'warn',
          );
          ubtSendTrace(
            245278,
            'sw_install',
            'download_fail',
            this.tempItem.name,
            this.tempItem.id,
            '',
            this.pvId,
            res.error_msg,
          );
          this.saveLog({
            title: 'download_error',
            target: 'installSoftware',
            softwareName: this.tempItem.name,
            softwareId: this.tempItem.id,
            description: res.error_msg,
            reserve1: 'SoftwareUpgrade > installSoftware',
          });
          this.step = 'check';
          this.handleClean();
          return;
        }
        const { source, downway } = res;
        let time = '';
        if (status === 'download start') {
          this.showProgressBar = true;
          let downIndex = 0;
          this.percentInterval = setInterval(() => {
            downIndex += 1;
            if (downIndex >= 12000) {
              clearInterval(this.percentInterval);
              this.showDialog(
                this.languages.softInstall.downloadNote,
                `${this.languages.softInstall.downTimeout}, ${this.languages.softInstall.retry}`,
                'warn',
              );
              if (this.saveMode) {
                this.saveMode = false;
                ubtSendTrace(
                  245278,
                  'sw_install',
                  'download_fail',
                  this.tempItem.name,
                  this.tempItem.id,
                  '',
                  this.pvId,
                  'download timeout',
                );
                this.saveLog({
                  title: 'download_error',
                  target: 'installSoftware',
                  softwareName: this.tempItem.name,
                  softwareId: this.tempItem.id,
                  description: 'download timeout',
                  reserve1: 'SoftwareUpgrade > installSoftware',
                });
              }
              this.downPercent = 0;
              this.setFooterTips('');
              this.showProgressBar = false;
              this.handleClean();
              return;
            }
            socket.sendSocket(0, 'idesk_query(percent)', (prs) => {
              if (prs.percent === 'error') {
                clearInterval(this.percentInterval);
                this.showDialog(
                  this.languages.softInstall.downloadNote,
                  `${this.languages.softInstall.downFailed}, ${this.languages.softInstall.retry}`,
                  'warn',
                );
                if (this.saveMode) {
                  this.saveMode = false;
                  ubtSendTrace(
                    245278,
                    'sw_install',
                    'download_fail',
                    this.tempItem.name,
                    this.tempItem.id,
                    '',
                    this.pvId,
                    'download percent error',
                  );
                  this.saveLog({
                    title: 'download_error',
                    target: 'installSoftware',
                    softwareName: this.tempItem.name,
                    softwareId: this.tempItem.id,
                    description: 'download percent error',
                    reserve1: 'SoftwareUpgrade > installSoftware',
                  });
                }
                this.downPercent = 0;
                this.setFooterTips('');
                this.showProgressBar = false;
                this.handleClean();
                return;
              }
              const downSize = Math.round((prs.size / 1024 / 1024) * 10) / 10;
              const totalSize = Math.round((prs.total / 1024 / 1024) * 10) / 10;

              if (downSize && totalSize) {
                this.setFooterTips(`${downSize}MB / ${totalSize}MB`);
                this.setDownloadSource(source);
              }
              if (prs.percent) this.downPercent = prs.percent;
              if (this.downPercent === '100') {
                clearInterval(this.percentInterval);
                time = prs.downTime;
                this.downPercent = 0;
                if (this.saveMode) {
                  this.saveMode = false;
                  ubtSendTrace(
                    245278,
                    'sw_install',
                    'download_suc',
                    this.tempItem.name,
                    this.tempItem.id,
                    '',
                    this.pvId,
                  );
                  this.saveLog({
                    title: 'download_success',
                    target: 'installSoftware',
                    softwareName: this.tempItem.name,
                    softwareId: this.tempItem.id,
                    description: 'normal',
                    reserve1: 'SoftwareUpgrade > installSoftware',
                    reserve2: time,
                    reserve3: source,
                    reserve4: downway,
                  });
                }
                this.setFooterTips('');
                this.showProgressBar = false;

                /* 6. send install command to local service with install datas */
                if (this.tempItem.showTips) {
                  this.$message({
                    showClose: true,
                    message: this.tempItem.showTips,
                    type: 'success',
                    duration: 0,
                  });
                }
                setTimeout(() => {
                  this.step = 'install';
                  this.saveMode = true;
                  if (!this.tempItem.installParams && this.isMessageShow) {
                    this.$message.warning({
                      message: this.languages.softInstall.installTip,
                      duration: this.languages.installTip || 5000,
                      showClose: true,
                    });
                    this.isMessageShow = false;
                  }
                  socket.sendSocket(0, `idesk_install(${this.tempSocketDatas})`, (irs) => {
                    console.log('idesk_install >>> ', irs);
                    const sts = irs.result;
                    if (sts !== 'install success') {
                      this.setDebugInfos(['SoftwareIninstall', irs.error_msg]);
                      this.setErrorTips(irs.error_msg);
                      this.showDialog(
                        this.languages.softInstall.installFail,
                        this.languages.softInstall.contact,
                        'warn',
                      );
                      if (Number(irs.error_msg)) {
                        if (this.saveMode) {
                          this.saveMode = false;
                          this.saveLog({
                            title: 'install_cancel',
                            target: 'installSoftware',
                            softwareName: this.tempItem.name,
                            softwareId: this.tempItem.id,
                            description: irs.error_msg,
                            reserve1: 'SoftwareUpgrade > installSoftware',
                          });
                        }
                      } else if (this.saveMode) {
                        this.saveMode = false;
                        this.saveLog({
                          title: 'install_error',
                          target: 'installSoftware',
                          softwareName: this.tempItem.name,
                          softwareId: this.tempItem.id,
                          description: irs.error_msg,
                          reserve1: 'SoftwareUpgrade > installSoftware',
                        });
                      }
                    } else {
                      const showInfo =
                        this.tempItem.softType && this.tempItem.softType !== 0
                          ? `${this.languages.softInstall.installInfo}\n${this.languages.softInstall.authTips}`
                          : this.languages.softInstall.installInfo;
                      this.showDialog(this.languages.softInstall.installed, showInfo);
                      if (this.saveMode) {
                        this.saveMode = false;
                        ubtSendTrace(
                          245278,
                          'sw_install',
                          'upgrade_suc',
                          this.tempItem.name,
                          this.tempItem.id,
                          '',
                          this.pvId,
                        );
                        this.saveLog({
                          title: 'install_success',
                          target: 'installSoftware',
                          softwareName: this.tempItem.name,
                          softwareId: this.tempItem.id,
                          description: 'normal',
                          reserve1: time,
                          reserve2: irs.time,
                          reserve3: source,
                          reserve4: downway,
                        });
                      }
                    }
                    this.step = 'check';
                    this.tempSocketDatas = '';
                    this.tempItem = '';
                    this.setFooterTips('');
                    this.handleClean();
                    this.homeTemplate.getUpgradeSoftList();
                  });
                }, 2000);
              }
            });
          }, 300);
        }
      });
    },
    hideInfoDialog() {
      this.dialogInfoVisible = false;
    },
    hideConfirmDialog() {
      this.dialogConfirmVisible = false;
    },
    stopDownload() {
      this.step = 'cancel';
      clearInterval(this.percentInterval);
      this.downPercent = 0;
      this.setFooterTips('');
      this.showProgressBar = false;
      if (this.isNewService) {
        const command = '({"level":"user", "method":"download_cancel", "data":""})';
        socket.sendSocket(2, command, (res) => {
          if (JSON.parse(res).data === 'Download Canceled') {
            this.handleClean();
          }
        });
        return;
      }
      try {
        socket.sendSocket(0, 'idesk_query(stopdown)');
      } catch (error) {
        console.log('error', error);
      } finally {
        this.connectSocketTimer = setInterval(async () => {
          await socket.initSocket(0);
          if (this.socketStatus[0].socket !== '' && this.socketStatus[0].readyState === 1) {
            clearInterval(this.connectSocketTimer);
            this.handleClean();
          }
        }, 1000);
      }
    },
    handleClean() {
      this.downPercent = 0;
      if (this.isNewService) {
        this.step = 'check';
        this.loaddingId = '';
        this.setIsRunning(false);
        return;
      }
      socket.sendSocket(0, 'idesk_query(clean)', (res) => {
        console.log('handleClean', res);
        // if (res.clean === 'ok') {
        this.step = 'check';
        this.loaddingId = '';
        this.setIsRunning(false);
        // }
      });
    },
  },
  created() {
    this.setPageNow('SoftwareUpgrade');
    this.setHomeHidden(false);
    this.setSearchHidden(true);
    this.setShowFooter(true);
    this.pvId = ubtRegister('Upgrade');
    this.setPvId(this.pvId);
  },
  beforeDestroy() {
    this.setSoftSearch('');
    const recommendList =
      this.languages.lan === 'cn' ? this.recommendSoftware : this.recommendSoftwareEn;
    this.setSoftTabPage(recommendList.length > 0 ? 'recommend' : 'common');
    this.setSelectSoftDetails(recommendList.length > 0 ? 'recommend' : 'common');
    clearInterval(this.connectSocketTimer);
    clearInterval(this.percentInterval);
  },
};
</script>

<style lang="scss" scoped>
.soft-container {
  background-color: #fff;
  padding: 0 10px;
  // position: relative;
}
.soft-title {
  height: 42px;
  font-size: 16px;
  line-height: 42px;
  color: #666;
  margin-left: 5px;
}
.is-disable {
  background-color: #999 !important;
  border: none !important;
}
.el-icon-loading {
  margin-right: 1px;
}
.soft-list {
  height: calc(100vh - 142px);
}
.soft-empty {
  display: flex;
  flex-direction: column;
  position: absolute;
  text-align: center;
  align-items: center;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  img {
    width: 200px;
    height: 200px;
  }
}
.soft-preview {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .soft-info {
    display: flex;
  }
  .img-preview {
    width: 48px;
    height: 48px;
    margin-right: 20px;
    margin-top: 5px;
  }
  .soft-name {
    font-weight: 700;
    line-height: 24px;
    color: #333;
    span {
      margin-left: 10px;
      // color: #409bff;
      font-weight: 400;
      font-size: 13px;
    }
  }
  .soft-desc {
    line-height: 16px;
    font-size: 13px;
    color: #999;
    max-width: 520px;
  }
  .soft-check {
    display: flex;
    align-items: center;
    margin-right: 8px;
  }
}
.single-container {
  height: 86px;
  padding-top: 10px;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  position: relative;
  margin-bottom: -1px;
  margin-left: 2px;
  margin-right: 5px;
}
.percent-bar {
  position: absolute;
  padding: 0 80px 0 95px;
  left: 0;
  right: 0;
  bottom: 5px;
}
.down-icon {
  position: absolute;
  left: 75px;
  color: #333;
}
.cancel-button {
  position: absolute;
  cursor: pointer;
  right: 65px;
  bottom: -2px;
}
.size-container {
  position: absolute;
  left: 10px;
  bottom: -33px;
  z-index: 1;
  font-size: 10px;
}
.button-container {
  display: flex;
  position: absolute;
  right: 10px;
}
</style>
